var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 107 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infinity_svg__a)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.796 23.75a23.978 23.978 0 0 0-2.546 4.262c-1.62 3.475-2.5 7.45-2.5 11.675 0 13.645 9.179 24.688 22.815 24.688 6.414 0 12.672-5.463 17.5-11.25 4.828-5.787 14.027-21.951 18.864-27.5C67.766 20.076 73.88 15 80.063 15c13.64 0 22.437 11.066 22.437 24.688 0 6.139-1.788 11.759-5 16.08m-58.75-36.11a30.355 30.355 0 0 1 2.5 2.292c5.16 5.268 8.904 12.474 11.875 17.738 3.269 5.789 8.194 13.93 14.375 19.255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15.002a23.445 23.445 0 0 0-5 .592M85 63.861a23.368 23.368 0 0 1-4.937.514H80",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infinity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h106.25v60H0z",
    transform: "translate(0 10)"
  })))));
};
export default SvgInfinity;